<!--  -->
<template>
    <div class="footr">
        <img class="footrlogo" style="width: 2.6rem;margin: 0 0 .48rem -0.35rem;" src="@/assets/images/all/logo_title.png" alt="">
        <div class="content" style="flex-wrap: nowrap;justify-content: space-between;" v-if="specification == 'pc'">

            <div class="lst" style="margin-right: 0;">
                <img style="width: 2.1rem;" src="@/assets/images/all/logo_title.png" alt="">
            </div>
            <div class="lst" style="margin-right: 0;">
                <p class="dan">
                    Products
                </p>
                <p class="shuang shuangactive" @click="solution1">
                    Atom Quantum Computer
                </p>
                <p class="shuang shuangactive" @click="solution2">
                    Quantum Control and Measurement
                </p>
                <p class="shuang shuangactive" @click="solution3">
                    Quantum Software and Cloud Platform
                </p>
                <p class="shuang shuangactive" @click="solution4">
                    Derivative Products and Services
                </p>
            </div>
            <div class="lst lstlem" style="margin-right: 0;">
                <p class="dan">
                    Related Links
                </p>
                <p class="shuang shuangactive" @click="product1">
                    China Computer Federation
                </p>
                <!-- <p class="shuang shuangactive" @click="product2">
                    中国电子信息产业发展研究院
                </p> -->
                <p class="shuang shuangactive" @click="product3">
                    The Chinese Institute of Electronics
                </p>
                <p class="shuang shuangactive" @click="product4">
                    Cold Atom Physics, Institute for Advanced Study, THU
                </p>
            </div>
            <div class="lst" style="margin-right: 0;">
                <p class="dan">
                    Contact Us
                </p>
                <p class="shuang ">
                    Email&nbsp;&nbsp;contact@qosmos.cn
                </p>
                <p class="shuang ">
                    Product Inquiry&nbsp;&nbsp;qsmarket@qosmos.cn
                </p>
                <p class="shuang ">
                    Tel&nbsp;&nbsp;010-50917160
                </p>
                <p class="shuang shuangac">
                    Address&nbsp;&nbsp; Building 1, Yard No. 7, Jinghui East Road, Economic-Technological Development Area, Beijing, China
                </p>
                <p class="shuang shuang_h5 ">
                    Address&nbsp;&nbsp; Building 1, Yard No. 7, Jinghui East Road, Economic-Technological Development Area, Beijing, China
                </p>
            </div>

        </div>

        <div class="content" style="flex-wrap: wrap;" v-if="specification == 'h5'">

            <div class="lst">
                <img style="width: 2.1rem;" src="@/assets/images/all/logo_title.png" alt="">
            </div>

            <div class="lst" style="width: 50%;margin: 0;">
                <p class="dan">
                    Products
                </p>
                <p class="shuang shuangactive" @click="solution1">
                    Atom Quantum Computer
                </p>
                <p class="shuang shuangactive" @click="solution2">
                    Quantum Control and Measurement
                </p>
                <p class="shuang shuangactive" @click="solution3">
                    Quantum Software and Cloud Platform
                </p>
                <p class="shuang shuangactive" @click="solution4">
                    Derivative Products and Services
                </p>
            </div>
            <div class="lst lstlem" style="width: 50%;margin-right: 0 !important;">
                <p class="dan">
                    Related Links
                </p>
                <p class="shuang shuangactive" @click="product1">
                    China Computer Federation
                </p>

                <p class="shuang shuangactive" @click="product3">
                    The Chinese Institute of Electronics
                </p>
                <p class="shuang shuangactive" @click="product4">
                    Cold Atom Physics, Institute for Advanced Study, THU
                </p>
            </div>

            <div class="lst">
                <p class="dan">
                    Contact Us
                </p>
                <p class="shuang ">
                    Email&nbsp;&nbsp;contact@qosmos.cn
                </p>
                <p class="shuang ">
                    Product Inquiry&nbsp;&nbsp;qsmarket@qosmos.cn
                </p>
                <p class="shuang ">
                    Tel&nbsp;&nbsp;010-50917160
                </p>
                <p class="shuang shuangac">
                    Address&nbsp;&nbsp; Building 1, Yard No. 7, Jinghui East Road, Economic-Technological Development Area, Beijing, China
                </p>
                <p class="shuang shuang_h5 ">
                    Address&nbsp;&nbsp; Building 1, Yard No. 7, Jinghui East Road, Economic-Technological Development Area, Beijing, China
                </p>
            </div>

        </div>

        <div class="codes">
            <div class="text">
                <span style="cursor: text;">© Qosmos Technology (Beijing) Co., Ltd. All rights reserved.</span>
                <span v-if="specification == 'pc'" @click="href(0)" style="margin: 0 .2rem;">
                    ICP Filing No.2024085260-2
                </span>
                <span v-else @click="href(0)">
                    <br />ICP Filing No.2024085260-2 <br />
                </span>
                <span @click="href(1)">
                    Public Security Filing No.11011502039193
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import router from '@/router';
import { mapState, mapGetters } from 'vuex'

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            scrollTop: 0,
            img: false
        };
    },
    //监听属性 类似于data概念
    computed: {
        ...mapGetters('user', ['specification'])         // 从 getters 里取
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        showWeChatImg() {
            let WeChatImg = this.$refs.WeChatImg
            WeChatImg.classList.add('activemouseenter');
            WeChatImg.classList.remove('activemouseleave');
            this.img = true

        },
        hideWeChatImg() {
            let WeChatImg = this.$refs.WeChatImg
            // WeChatImg.classList.add('activemouseleave');
            // WeChatImg.classList.remove('activemouseenter');
            this.img = false
        },
        href(e) {
            if (e == 0) {
                window.open('https://beian.miit.gov.cn')
            } else if (e == 1) {
                window.open('https://beian.mps.gov.cn')
            }
        },
        // 解决方案
        solution1() {

            this.$bus.$emit("nextaboutitem", 1);
            this.$store.commit('user/SET_PRODTYPE', "computer")
            this.$router.push('/en/products')
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.scrollToTarget('#product-section', 100);
        },
        solution2() {
            this.$bus.$emit("nextaboutitem", 1);
            this.$store.commit('user/SET_PRODTYPE', "instrument")
            this.$router.push('/en/products')
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.scrollToTarget('#product-section', 100);

        },
        solution3() {
            this.$bus.$emit("nextaboutitem", 1);
            this.$store.commit('user/SET_PRODTYPE', "software")
            this.$router.push('/en/products')
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.scrollToTarget('#product-section', 100);

        },
        solution4() {
            this.$bus.$emit("nextaboutitem", 1);
            this.$store.commit('user/SET_PRODTYPE', "service")
            this.$router.push('/en/products')
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
            this.scrollToTarget('#product-section', 100);

        },
        product1() {
            window.open("https://www.ccf.org.cn/en/")
            // this.$bus.$emit("nextaboutitem", 1);
            // this.$store.commit('user/SET_PRODTYPE', "computer")
            // this.$router.push('/products')
        },
        product2() {
            window.open("https://www.ccidgroup.com/")

            // this.$bus.$emit("nextaboutitem", 1);
            // this.$store.commit('user/SET_PRODTYPE', "computer")
            // this.$router.push('/products')
        },
        product3() {
            window.open("https://www.cie.org.cn/")

            //     this.$router.push('/swimstystem')
            //     this.$bus.$emit("nextaboutitem", 2);
        },

        product4() {
            window.open("https://www.quantumgases.cn/")

        },




        scrollToTarget(hash, offset = 100) {
            this.$router.push({ path: '/en/products', hash }).then(() => {
                // 使用 $nextTick 保证 DOM 更新完毕
                this.$nextTick(() => {
                    // 延时 300ms 确保页面中所有元素已加载（根据实际情况调整延时）
                    setTimeout(() => {
                        const target = document.querySelector(hash);
                        if (target) {
                            // 获取目标元素相对于视口的距离
                            const rect = target.getBoundingClientRect();
                            // 当前页面滚动距离（兼容不同浏览器）
                            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            // 计算最终滚动位置：目标元素顶部位置 + 额外偏移量
                            const targetPosition = rect.top + scrollTop - offset;
                            window.scrollTo({
                                top: targetPosition,
                                behavior: 'smooth'
                            });
                        }
                    }, 10);
                });
            });
            // 触发其他事件（例如：更新 about 页面的选中状态）
            this.$bus.$emit("nextaboutitem", 3);
        },
    },
    beforeCreate() { }, //生命周期 - 创建之前
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    beforeMount() { }, //生命周期 - 挂载之前
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() {

    }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
.footr {
    width: 100%;
    box-sizing: border-box;
    padding: 0.5rem 0rem 0.2rem;
    background-color: #00012d !important;
}

.footr .content {
    max-width: 17rem;
    height: 100%;
    margin: 0rem auto;
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 1.2rem 0;
    border-bottom: 0.01rem solid;
    border-image: linear-gradient(
            90deg,
            rgba(106, 36, 146, 0),
            rgba(143, 49, 197, 1),
            rgba(69, 24, 95, 0)
        )
        1 1;
}

.footr .content .lst {
    margin-right: 0.55rem;
}

.footr .content .lst:nth-child(1) {
    margin-top: -0.2rem;
}
.footr .content .lst .dan:nth-child(1) {
    font-family: "NotoSansHans-Bold";
    font-weight: bold;
}
.footr .content .lst .dan {
    font-family: "NotoSansHans-Regular";
    font-size: 0.16rem;
    color: rgba(225, 225, 225, 0.98);
    margin: 0 0 0.14rem 0;
}

.footr .content .lst .shuang {
    font-size: 0.14rem;
    color: #ffffff;
    line-height: 0.35rem;
}

.shuangactive {
    &:hover {
        cursor: pointer;
        color: #8f8dec !important;
        text-decoration: dotted;
        text-decoration: underline;
    }
}

.footr .content .lst:nth-child(2),
.footr .content .lst:nth-child(3),
.footr .content .lst:nth-child(4) {
    .shuang {
        color: rgba(225, 225, 225, 0.7);
    }
}

.footr .content .lst .lst2 {
    // margin-left: 0.2rem;
}

.lst2 .di {
    width: 1.18rem;
    height: 1.18rem;

    img {
        width: 100%;
        height: 100%;
    }
}

.lst2_box {
    display: flex;
    justify-content: space-between;
}

.footr .content .lst3 {
    width: 2.68rem;
    margin-right: 0rem;
    // border-left: 0.01rem solid #bbb;
}

.footr .content .lst3 .di {
    margin-top: 0.23rem;
}

.codes {
    display: flex;
    justify-content: center;
    margin: 0.5rem 0 0 0;

    .text {
        width: 12rem;
        height: 0.4rem;
        font-weight: 400;
        font-size: 0.14rem;
        color: #959595;
        text-align: center;
        cursor: pointer;
    }
}

.title_mobile {
    display: none;
}

// @media screen and (max-width: 7.5rem) {
//     .content {
//         display: none !important;
//     }

//     .codes {
//         margin: 0.1rem 0 0 0 !important;
//         padding: 0 0 0 0.23rem;

//         .text {
//             text-align: start !important;
//         }
//     }

//     .title_mobile {
//         display: block !important;
//         padding: 0 0.43rem;

//         .title_company {
//             font-size: 0.24rem;
//             font-weight: 400;
//             letter-spacing: 0rem;
//             line-height: 0.3475rem;
//             color: rgba(255, 255, 255, 1);
//         }

//         .company {
//             display: flex;
//             justify-content: space-between;

//             .company_content {
//                 color: rgba(255, 255, 255, 1);
//                 font-size: 0.2rem;
//                 font-weight: 400;

//                 .line-height {
//                     line-height: 0.3475rem;
//                 }
//             }

//             .company_img {
//                 display: flex;
//             }
//         }
//     }
// }
.footrlogo,
.shuang_h5 {
    display: none;
}
@media screen and (max-width: 750px) {
    .shuangac {
        display: none;
    }
    .footrlogo,
    .shuang_h5 {
        display: block;
    }
    .footr {
        padding: 0.56rem 0.54rem 0.33rem 0.5rem;
        display: flex;
        flex-direction: column;

        .footrlogo {
            width: 1.97rem !important;
            margin: 0 0 0.3rem 0 !important;
        }

        .content {
            width: 6.42rem;
            margin: 0;
            justify-content: flex-start !important;
            column-gap: 0.34rem;
            padding: 0 0 1.33rem 0;
            border-bottom-width: 0.02rem;
            .lst:nth-child(1) {
                display: none;
            }

            .lst:nth-child(2) {
                width: 2.92rem !important;
                margin: 0 !important;
            }

            .lstlem {
                width: 2.92rem !important;
                margin: 0 !important;
            }

            .lst:nth-child(4) {
                width: 6.23rem;
                margin: 0.89rem 0 0 0 !important;
            }

            .lst {
                margin-right: 0;

                .dan {
                    margin-bottom: 0.3rem;
                }

                p {
                    margin: 0 0 0.15rem 0;
                    font-size: 0.14rem !important;
                    line-height: 0.21rem;
                    letter-spacing: 0;
                }

                .dan {
                    font-size: 0.2rem !important;
                    line-height: 0.3rem;
                }
            }

            .lst:nth-child(4) {
                .shuang {
                    margin-bottom: 0.01rem;
                }
            }

            .lst3 {
                .dan {
                    font-size: 0.2rem !important;
                    line-height: 0.3rem;
                }
            }
        }

        .codes {
            margin: 0.2rem 0 0 0;

            br {
                display: none;
            }

            .text {
                width: 100%;
                height: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 0.14rem !important;
                line-height: 0.21rem;
                letter-spacing: 0;
                text-align: center;

                span {
                    display: block;
                    margin: 0 0 0.2rem 0 !important;
                    line-height: 0.21rem;
                }

                span:nth-child(1) {
                    order: 2;
                }

                span:nth-child(2) {
                    order: 1;
                }

                span:nth-child(3) {
                    order: 3;
                    margin-bottom: 0 !important;
                }
            }
        }
    }
}
</style>
